import React from 'react';

/**
 * Wraps children in the four-corner bracket frame used throughout this app
 * (login card, image viewport) — borrowed from how PACS/DICOM viewers frame
 * an image on screen. Optional `label` renders bottom-right, mimicking a
 * viewer's small readout (zoom %, orientation, etc.).
 */
export default function ViewportFrame({ children, className = '', label }) {
  return (
    <div className={`viewport-frame ${className}`}>
      <span className="vf-tr" />
      <span className="vf-br" />
      {children}
      {label && (
        <span className="absolute bottom-2 right-3 text-[10px] font-data text-phosphor/70 pointer-events-none">
          {label}
        </span>
      )}
    </div>
  );
}
